

/**
 * Valida si una dirección de correo electrónico es válida.
 * @param {Object} options - Opciones de validación.
 * @param {string} options.email - Dirección de correo electrónico a validar.
 * @returns {boolean} - Devuelve true si la dirección de correo electrónico es válida, de lo contrario, devuelve false.
 */
const validEmail = ({ email, }) => {
    if (typeof email !== "string") {
        return false;
    }
    if (email.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    )) {
        return true;
    }
    else return false;
}

/**
 * Valida la longitud de una cadena de texto.
 * @param {Object} options - Opciones de validación.
 * @param {string} options.text - Cadena de texto a validar.
 * @param {number} options.min - Longitud mínima permitida.
 * @param {number} options.max - Longitud máxima permitida.
 * @returns {boolean} - Devuelve true si la cadena de texto tiene una longitud válida, de lo contrario, devuelve false.
 */
const validStringLength = ({ text, min, max, }) => {
    if (typeof text === 'string' && typeof min === 'number' && typeof max === 'number') {
        return text.length <= max && text.length >= min
    }
    else
        return false;
}

/**
 * Valida la longitud de un número.
 * @param {Object} options - Opciones de validación.
 * @param {number} options.number - Número a validar.
 * @param {number} options.min - Valor mínimo permitido.
 * @param {number} options.max - Valor máximo permitido.
 * @returns {boolean} - Devuelve true si el número tiene una longitud válida, de lo contrario, devuelve false.
 */
const validNumberLength = ({ number, min, max, }) => {
    if (typeof number === 'number' && typeof min === 'number' && typeof max === 'number') {
        return number <= max && number >= min
    }
    else
        return false;
}


/**
 * Compara dos valores y verifica si son iguales.
 * @param {*} value1 - Primer valor a comparar.
 * @param {*} value2 - Segundo valor a comparar.
 * @returns {boolean} - Devuelve true si los valores son iguales, de lo contrario, devuelve false.
 */
const equalValues = (value1, value2) => {
    return value1 === value2
}

/**
 * Realiza múltiples validaciones y devuelve el resultado.
 * @param {Object[]} validations - Lista de validaciones.
 * @param {boolean} validations[].validation - Resultado de la validación (true o false).
 * @param {string} validations[].errorMessage - Mensaje de error en caso de que la validación falle.
 * @returns {string|boolean} - Devuelve true si todas las validaciones son exitosas, de lo contrario, devuelve el mensaje de error de la primera validación fallida.
 */
const multipleValidations = (validations) => {
    let response = true;
    for (let i = 0; i < validations.length; i++) {
        const element = validations[i];
        if (element.validation === false) {
            response = element.errorMessage
            break;
        }
    }
    return response;
}

/**
 * Valida si un valor contiene solo letras, números y ciertos caracteres especiales.
 * @param {string} value - Valor a validar.
 * @returns {boolean} - Devuelve true si el valor contiene solo letras, números y ciertos caracteres especiales, de lo contrario, devuelve false.
 */
const onlyLettersAndNumbers = (value) => {
    if (typeof value !== "string") {
        return false;
    }
    if (value.match(
        /^([a-zA-Z0-9 _-]+)$/
    )) {
        return true;
    }
    else return false;

}





/**
 * Objeto que contiene funciones de validación.
 */
export const FormValidations = {
    validEmail,
    validNumberLength,
    validStringLength,
    equalValues,
    multipleValidations,
    onlyLettersAndNumbers
}